"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplementationRuleIds = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
class ImplementationRuleIds {
    static { this.RULE_ID_PREFIX = 'imrrule_'; }
    static { this.SECTION_ID_PREFIX = 'imrsec_'; }
    static { this.DRAFT_SECTION_ID_PREFIX = 'draft_section_'; }
    static { this.OPERATOR_RULE_RANDOM_LENGTH = 36; }
    static { this.DRAFT_SECTION_RANDOM_LENGTH = 12; }
    static mintOperatorRuleId() {
        return (ImplementationRuleIds.RULE_ID_PREFIX + sigma_engine_shared_1.Utils.randomAlphaStr(ImplementationRuleIds.OPERATOR_RULE_RANDOM_LENGTH));
    }
    static mintDraftSectionId() {
        return (ImplementationRuleIds.DRAFT_SECTION_ID_PREFIX +
            sigma_engine_shared_1.Utils.randomAlphaStr(ImplementationRuleIds.DRAFT_SECTION_RANDOM_LENGTH));
    }
}
exports.ImplementationRuleIds = ImplementationRuleIds;
//# sourceMappingURL=implementation-rule-ids.js.map